<template>
  <div @click="visualDeselect">
    <b-container class="pb-1 pt-0 pl-0 pr-0 m-0" fluid="true" data-test-path='image-gallery-header'>
      <b-row no-gutters>
        <edit-save-button
            v-if="!isJoined"
            :save-edit-mode="readOnly"
            @edit="edit"
            @save="save(false)"
        ></edit-save-button>

        <b-col cols="auto" class="p-0 pt-1 pl-sm-2">
          <b-container class="p-0">
            <b-row no-gutters>
              <b-col cols="auto" class="p-0" v-if="!readOnly">
                <FileUpload

                    data-test-path="image-upload"
                    class="d-none d-lg-block"
                    @file-selected="imageSelected"
                    ref="imageUpload"
                />
                <span class="d-block d-lg-none" v-if="loading" style="width: 40px; padding-top: 5px">
                            {{ percentDone }} %
                          </span>
                <b-button v-else
                          class="d-block d-lg-none"
                          variant="plm-toolbar-secondary"
                          @click="uploadImage"
                          style="width: 40px"
                >
                  <font-awesome-icon icon="upload"/>
                </b-button>
              </b-col>
              <b-col cols="auto" class="pr-1 pl-1">
                <b-button-group>
                  <b-button data-test-path="small-size-button" @click="resizeImage(90)" variant="plm-toolbar-secondary">
                    <font-awesome-icon class="fa-sm" icon="image"/>
                  </b-button>
                  <b-button data-test-path="medium-size-button" @click="resizeImage(140)"
                            variant="plm-toolbar-secondary"
                            style="width: 40px; height: 38px; padding: 0 3px;" class="d-none d-sm-inline-block">
                    <font-awesome-icon class="fa-lg" icon="image"/>
                  </b-button>
                  <b-button data-test-path="large-size-button" @click="resizeImage(300)" variant="plm-toolbar-secondary"
                            style="padding: 0 3px; height: 38px">
                    <font-awesome-icon style="padding-top: 3px" class="fa-2x" icon="image"/>
                  </b-button>
                </b-button-group>

              </b-col>
              <b-col cols="auto" class="pr-1" v-if="checkIsCordova">
                <CameraButton
                    :listOfImagesInGalleryCard = "listOfImagesInGalleryCard"
                    @push-uploaded-file="imageTakenByCordova"
                    ref="imageUploadByCordova"
                ></CameraButton>
              </b-col>
              <b-col class="d-none d-xl-block" cols="auto">
                <b-button data-test-path="zoom-image" class="mr-1" @click="zoomImage"
                          ref="zoomBtnSm"
                          :disabled="!selectedImage"
                          variant="plm-toolbar-secondary">
                  <font-awesome-icon class="mr-1" icon="search"/>
                  Zoom in
                </b-button>
              </b-col>
              <b-col class="d-block d-xl-none pr-1 pl-0 " cols="auto">
                <b-button @click="zoomImage" :disabled="!selectedImage"
                          ref="zoomBtnMd"
                          style="width: 40px; padding-left: 10px"
                          data-test-path="zoom-image"
                          variant="plm-toolbar-secondary">
                  <font-awesome-icon icon="search"/>
                </b-button>
              </b-col>
              <b-col cols="auto" class="d-none d-xl-block p-0">
                <b-button
                    data-test-path="share-image"
                    :disabled="!selectedImage"
                    @click="shareImage"
                    variant="plm-toolbar-secondary"
                    ref="shareBtnSm"
                >
                  <font-awesome-icon class="ml-1" icon="share-alt"/>
                  Share
                </b-button>
              </b-col>
              <b-col cols="auto" class="d-block d-xl-none pr-1 pl-0 ">
                <b-button
                    data-test-path="share-image"
                    :disabled="!selectedImage"
                    @click="shareImage"
                    variant="plm-toolbar-secondary"
                    ref="shareBtnMd"
                >
                  <font-awesome-icon icon="share-alt"/>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col class="p-0 pr-1 d-flex justify-content-end" v-if="!readOnly">
          <b-button
              class="d-none d-xl-block mt-1"
              data-test-path="delete-image"
              variant="plm-toolbar-danger"
              :disabled="!selectedImage"
              ref="delSm"
              @click="deleteImage"
          >
            <font-awesome-icon class="ml-1" icon="trash"/>
            Remove
          </b-button>
          <b-button
              class="d-block d-xl-none text-right mt-1"
              data-test-path="delete-image"
              variant="plm-toolbar-danger"
              :disabled="!selectedImage"
              ref="delMd"
              @click="deleteImage"
          >
            <font-awesome-icon icon="trash"/>
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <VBox ref="vbox" :scrollable="true" >
      <b-container fluid="true" class="pt-4 pb-2 bg-dark ">
        <b-row class="text-center m-0 d-flex justify-content-center" >
          <div
              class="card bg-light-shade p-2 my-2 text-center text-wrap mx-auto mx-lg-2 mx-sm-auto"
              v-for="(image, index) in listOfImagesInGalleryCard"
              :key="image.token"
              :style="'width: ' + (imageSize+50) + 'px; '">
            <b-col
                   ref="listOfImagesInGalleryCard"
                   class="card-img-top"
                   :data-test-path="'image' + index"
                   tabindex="0"
                   @click.stop="focusIn(image, index)"
                   @focusin="focusIn(image, index)"
                   @focusout="focusOut($event, image, index)"
                   @dblclick="zoomImage()"
                   thumbnail
                   fluid>
              <b-img
                  v-if="!checkIsCordova"
                  cols="auto"
                  :style="'max-height: ' + imageSize + 'px; margin-top: 20px; max-width: ' + imageSize + 'px; '"
                  :data-test-path="'image' + index"
                  class="fitSizeImage py-2"
                  :src="image.url"></b-img>
              <b-img
                  v-else
                  cols="auto"
                  :style="'max-height: ' + imageSize + 'px; max-width: ' + imageSize + 'px; '"
                  :data-test-path="'image' + index"
                  class="fitSizeImage py-2"
                  :src="$secureUrl(addCordovaUrl + image.url)"></b-img>
            </b-col>
            <div v-if="!readOnly" class="position-absolute" :data-test-path="'star-' + index" style="right: 0; margin-right: 10px" @click="setImageAsMain(image)">
              <div :class="image.starState"></div>
            </div>
            <!--            <b-col :style="'margin: 0 auto; max-width: ' + imageSize + 'px'" class="pb-3 pl-0 pr-0">-->
            <b-col :style="'margin: 0 auto;'" class="pb-3 ">
              <a v-if="!checkIsCordova" style="color: white" class="line-clamp wrap text-dark" :href="image.downloadUrl">
                <font-awesome-icon class="fa-sm mr-1 " icon="download"/>
                {{ image.data.name }}
              </a>
              <a v-else style="color: white" class="line-clamp wrap text-dark" :href="$secureUrl(addCordovaUrl + image.downloadUrl)">
                <font-awesome-icon class="fa-sm mr-1 " icon="download"/>
                {{ image.data.name }}
              </a>
              <div class="tag-line bg-dark"></div>
              <div v-if="image && image.customData && image.customData.imageTagList" class="image-tags text-dark">
                <span v-if="tag.visible === true" v-for="tag in image.customData.imageTagList" :key="tag.id">#{{ tag.name }}</span>
              </div>
              <div class="add-remove-tag " v-if="!readOnly">
                <span  @click="openModal(image)" :style="readOnly ? '' : 'cursor: pointer;'">
                  <a class="line-clamp user-select-none text-dark"
                  :data-test-path="'tags-'+ index">
                     Edit Tags <font-awesome-icon icon="tag" transform=""></font-awesome-icon>
                  </a>
                </span>
              </div>
            </b-col>
          </div>
        </b-row>
      </b-container>
    </VBox>

    <FooterNavbar data-test-path="image-gallery-footer">
      <CloseButton :read-only="readOnly" @close="cancel"></CloseButton>

      <footer-button type="Details" :disabled="!lastSelectedImage"  @details="zoomImage"></footer-button>
      <save-and-close-button mode="EDIT" @save="save" v-if="!readOnly"></save-and-close-button>

    </FooterNavbar>
  </div>
</template>

<script>
import Activity from "@/activity/Activity";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FileUpload from "@/components/FileUpload";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import DialogManager from "@/utils/DialogManager";
import ActivityManager from "@/activity/ActivityManager";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import EditSaveButton from "@/components/layout/EditSaveButton";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
import {isElementIn} from "@/utils/Dom";
import ImageTag from "@/server/com/silkplm/model/plm/dictionaries/ImageTag";
import ListOfImageTag from "@/server/com/silkplm/rpc/plm/ListOfImageTag";
import CameraButton from "@/components/inputs/CameraButton.vue";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";

const SlideShow = () => require("@/components/img/SlideShow");

export default {
  name: "ImageGalleryCard",
  computed:{
    checkIsCordova(){
      return window.isCordova
    },
    addCordovaUrl(){
      return window.cordovaUrl
    }
  },
  components: {
    CameraButton,
    SaveAndCloseButton,
    EditSaveButton,
    FooterButton,
    SlideShow,
    FileUpload,
    FooterNavbar,
    VBox,
    CloseButton
  },

  async mounted() {
    // this.allTags = await ImageTag.list();

    this.allTagsFromDB = await ImageTag.list();

    for (let tag of this.allTagsFromDB){
      if(tag.visible){
        this.allTags.push(tag);
      }
    }

    for (let tag of this.allTags) {
      tag.text = tag.name;
      tag.value = tag.name;
    }
    if (!this.makeSureMainPhotoIsSet()){
      this.setImageAsMain(this.listOfImagesInGalleryCard[0]);
    }

    if(this.isJoined){
      this.readOnly = true;
    }


  },

  methods: {
    ...Activity.methods,

    deselectImageAsMain(image){
      if(image.customData != null && image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
        image.customData.imageTagList = image.customData.imageTagList.filter(tag => tag.name !== 'Main Picture');
        image.starState = "star-outline";
      }
    },

    setImageAsMain(image){
      this.selectedImage = image;
      if(image.customData != null && image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
        this.deselectImageAsMain(image);
      }else if(this.makeSureMainPhotoIsSet()){
        this.deselectImageAsMain(this.mainImageInstance);
        this.setImageAsMain(this.selectedImage);
      }
      else{
        let customData = this.selectedImage.customData;
        if (!customData) {
          customData = new ListOfImageTag();
          customData.type = customData.getRemoteClass();
          customData.imageTagList = [];
        } else if (!customData.imageTagList) {
          customData.imageTagList = [];
        }
        for (let tag of this.allTagsFromDB) {
          if (tag.name === "Main Picture")
            customData.imageTagList.push(tag);
        }
        image.starState = "star"

        this.selectedImage.customData = customData;
      }

      const originalIndex = this.listOfImagesInGalleryCard.findIndex(img => img.data.firId === image.data.firId);
      if (originalIndex !== -1) {
        this.listOfImagesInGalleryCard.splice(originalIndex, 1);
      }
      this.listOfImagesInGalleryCard.splice(originalIndex, 0, this.selectedImage);
    },

    openModal(image) {
      if (this.readOnly) {
        return;
      }
      this.selectedImage = image;

      let assignedTags = [];
      if (image.customData && image.customData.imageTagList) {
        assignedTags = image.customData.imageTagList;
      }
      let availableTags = [];
      for (let tag of assignedTags) {
        tag.text = tag.name;
        tag.value = tag.name;
      }
      for (let tag of this.allTags) {
        tag.__numberOfUsedTag = 0;
        for (let image of this.listOfImagesInGalleryCard) {
          if (image.customData?.imageTagList) {
            for (let assignedTagToImage of image.customData.imageTagList) {
              if (assignedTagToImage.id === tag.id) {
                tag.__numberOfUsedTag++;
              }
            }
          }
        }
      }
      for (let tag of this.allTags) {
        if (tag.__numberOfUsedTag < tag.quantityTag) {
          availableTags.push(tag);
        } else {
          let index = _.findIndex(assignedTags, ['id', tag.id]);
          if (index !== -1) {
            availableTags.push(tag);
          }
        }
      }
      availableTags.sort((a, b) => {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0; // Zwrócenie 0 w przypadku równości
      });
      DialogManager.multiSelect($tr("addOrRemoveTagis","Add or remove tags"), availableTags, assignedTags).then(tags => {
        let customData = this.selectedImage.customData;
        let isSetMainPicture = false;
        let tempCustomData = [];

        if (!customData) {
          customData = new ListOfImageTag();
          customData.type = customData.getRemoteClass();
          customData.imageTagList = [];
        } else if (!customData.imageTagList) {
          customData.imageTagList = [];
        }
        if (!tags || !tags.length) {
          customData.imageTagList = [];
        } else {
          isSetMainPicture = customData.imageTagList.some(tag => {
            if (tag.name === "Main Picture") {
              tempCustomData.push(tag);
              return true;
            }
            return false;
          });

          customData.imageTagList = [];
          for (let tag of tags) {
            customData.imageTagList.push(tag);
          }

          if (isSetMainPicture) {
            const mergedArray = customData.imageTagList.concat(tempCustomData);
            customData.imageTagList = mergedArray.filter((item, index) => {
              return mergedArray.findIndex(i => i.name === item.name) === index;
            });
            tempCustomData = [];
          }
        }

        this.selectedImage.customData = customData;
        this.listOfImagesInGalleryCard = this.listOfImagesInGalleryCard.filter(img => img.data.firId != image.data.firId);
        this.listOfImagesInGalleryCard.push(this.selectedImage);
      })
    },
    makeSureMainPhotoIsSet(){
      if(this.listOfImagesInGalleryCard.length !== 0) {
        for (let image of this.listOfImagesInGalleryCard) {
          if (image.customData != null && image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
            this.mainImageInstance = image;
            return true;
          }
        }
        return false;
      }
      else {
        return true;
      }
    },
    getTitle() {
      return "Image gallery";
    },

    focusOut(event, selectedImage, index) {
      if (isElementIn(event.relatedTarget,
          [this.$refs.zoomBtnSm, this.$refs.delSm, this.$refs.shareBtnMd, this.$refs.shareBtnSm,
            this.$refs.delMd, this.$refs.zoomBtnMd])) {
        return;
      }


    },

    deselect() {
      this.$refs.listOfImagesInGalleryCard.forEach(el => el.classList.remove("selected-item"));
      this.selectedImage = null;
    },

    visualDeselect() {
      if ( this.listOfImagesInGalleryCard.length !== 0 &&
          (this.lastSelectedIndex || this.lastSelectedIndex === 0) &&
          this.$refs.listOfImagesInGalleryCard[this.lastSelectedIndex].classList.contains("selected-item"))
      {
        this.$refs.listOfImagesInGalleryCard[this.lastSelectedIndex].classList.remove("selected-item");
      }
    },

    async focusIn(selectedImage, index) {
      if ((this.lastSelectedIndex || this.lastSelectedIndex === 0) && this.$refs.listOfImagesInGalleryCard[this.lastSelectedIndex].classList.contains("selected-item")) {
        this.$refs.listOfImagesInGalleryCard[this.lastSelectedIndex].classList.remove("selected-item");
      }
      this.selectedImage = selectedImage;
      this.lastSelectedImage = this.selectedImage;
      this.lastSelectedIndex = index;
      this.$refs.listOfImagesInGalleryCard[index].classList.add("selected-item");

    },

    async imageSelected() {
      let imageUpload = this.$refs.imageUpload;
      let file = imageUpload.getFile();
      imageUpload.setProgress(0);
      try {
        let uploadedImage = await Rpc.BusinessEntities.uploadImage(file, "").lock().onProgress((e) => {
          imageUpload.setProgress(e.percent);
        });
        if (uploadedImage) {
          if (this.formConfig.formClassLong === ProductInSeason.getRemoteClass()) {
            let ppSampleGuideTag = await Rpc.plm.services.DictionaryService.findPPSampleGuideTag();
            if (ppSampleGuideTag != null) {
              let customData = new ListOfImageTag();
              customData.type = customData.getRemoteClass();
              customData.imageTagList = [];
              customData.imageTagList.push(ppSampleGuideTag);
              uploadedImage.customData = customData;
            }
          }
          this.listOfImagesInGalleryCard.push(uploadedImage);
          this.numberOfUnsavedImages++;
        }
        imageUpload.reset();
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          imageUpload.setError(e.fields.image.errorMessage);
        }
      }
    },
    async imageTakenByCordova() {
      let imageUpload = this.$refs.imageUploadByCordova;
      let file = imageUpload.getFile();
      try {
        let uploadedImage = await Rpc.BusinessEntities.uploadImage(file, "").lock()
        if (uploadedImage) {
          this.listOfImagesInGalleryCard.push(uploadedImage);
          this.numberOfUnsavedImages++;
        }
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          console.log(e.fields.image.errorMessage);
        }
      }
    },
    beforeClose() {
      let listOfImagesInGalleryCard = this.resultList;
      let numberOfUnsavedImages = this.numberOfUnsavedImages;
      this.result = {listOfImagesInGalleryCard, numberOfUnsavedImages};
      this.setResult(this.result);
    },

    cancel() {
      if (this.shouldSave) {
        this.$emit("save", this.result);
      }
      this.close();
    },

    async canClose() {
      if (await DialogManager.canClose(!this.readOnly && this.numberOfUnsavedImages > 0)) {
        this.readOnly = false;
        return true;
      }
      return false;
    },

    save(autoClose = true) {
      this.shouldSave = true;
      if (this.listOfImagesInGalleryCard.length === 1 && !this.makeSureMainPhotoIsSet()) {
        this.setImageAsMain(this.listOfImagesInGalleryCard[0]);
      }

      let originalListOfImages = [... this.originalListOfImages];

      if(this.makeSureMainPhotoIsSet()){
        this.resultList = this.listOfImagesInGalleryCard;
        this.result = {listOfImagesInGalleryCard: this.resultList, numberOfUnsavedImages: this.numberOfUnsavedImages};

        originalListOfImages = this.resultList;
        // this.numberOfUnsavedImages = 0;

        this.readOnly = true;
        if (autoClose) {
          this.$emit("save", this.result);
          this.close();
        }
      } else {
        DialogManager.info($tr('imageGalleryCard.no.save','Save not available'),
            $tr('imageGalleryCard.choose.photo','The main photo has not been set, please choose one photo to be set as the main one.'));
      }
    },

    edit() {
      this.readOnly = false;
      setTimeout(() => {
        this.$refs.vbox.sizeChanged();
      });
    },

    resizeImage(size) {
      this.imageSize = size;
    },

    async zoomImage() {
      this.deselect();
      let originalListOfImages = [... this.originalListOfImages];
      if (this.lastSelectedImage) {
        let slideShow = await ActivityManager.showActivity(SlideShow, {
          image: this.lastSelectedImage,
          imagesList: this.listOfImagesInGalleryCard,
          isJoined: this.isJoined
        });
        slideShow.$on("new-image", (image) => {
          this.listOfImagesInGalleryCard.push(image);
          this.numberOfUnsavedImages++;
        });
        slideShow.$on("refactor-image", (deletedImage, newImage) => {
          let index = _.findIndex(this.listOfImagesInGalleryCard, ['token', deletedImage.token]);
          let originalListElementIndex = _.findIndex(originalListOfImages, {'token': deletedImage.token});
          if (originalListElementIndex === -1) {
            this.numberOfUnsavedImages--;
          }
          else{
            originalListOfImages[index] = newImage;
          }
          this.listOfImagesInGalleryCard[index] = newImage;
          this.save(false);
        });
      }

    },

    uploadImage() {
      this.$refs.imageUpload.$refs.fileInput.click();
    },

    async shareImage() {
      this.deselect();

      if (this.lastSelectedImage) {
        this.$refs.listOfImagesInGalleryCard[this.lastSelectedIndex].classList.add("selected-item");
        await DialogManager.shareAttachmentDialog([this.lastSelectedImage]);
      }
    },

    async deleteImage() {
      this.deselect();
      if (this.lastSelectedImage) {
        this.$refs.listOfImagesInGalleryCard[this.lastSelectedIndex].classList.add("selected-item");
        if (await DialogManager.yesNo($tr('imageGalleryCard.delete','Deleting image'),
            $tr('imageGalleryCard.sure.delete','Are you sure you want to delete this image?'))) {
          await this.deleteImageSubmit();
        }
      }
    },

    async deleteImageSubmit() {
      let originalResult = _.find(this.originalListOfImages, {"token": this.lastSelectedImage.token});
      let tempResult = _.find(this.listOfImagesInGalleryCard, {"token": this.lastSelectedImage.token});
      if (originalResult) {
        this.numberOfUnsavedImages++;

      }
      if (!originalResult && tempResult) {
        this.numberOfUnsavedImages--;
      }
      let index = _.findIndex(this.listOfImagesInGalleryCard, ['token', tempResult.token]);
      this.listOfImagesInGalleryCard.splice(index, 1);
      this.lastSelectedIndex = null;
      this.lastSelectedImage = null;
    },
  },
  watch: {
    listOfImagesInGalleryCard: {
      handler(newList) {
        newList.forEach(image => {
          if (!image.starState) {
            image.starState = "star-outline";
          }
        });
      },
      deep: true // opcjonalne, umożliwia obserwowanie zmian w głąb obiektu
    }
  },
  props: {
    numberOfUnsavedImages: {type: Number, default: 0},
    listOfImagesInGalleryCard: {type: Array, default: []},
    originalListOfImages: {type: Array, default: []},
    isJoined: {type: Boolean, default: false},
    formConfig: {default: null}
  },
  data: () => ({
    readOnly: false,
    loading: false,
    percentDone: null,
    listOfSelectedImage: [],
    numberOfSelectedRows: 0,
    isSelectedImage: false,
    selectedImage: null,
    lastSelectedImage: null,
    lastSelectedIndex: null,
    mainImageInstance: null,
    resultList: [],
    imageSize: 140,
    imgHeightList: [],
    allTags: [],
    allTagsFromDB: [],
    shouldSave: false
  })

}
</script>

<style scoped>

.wrap {
  word-wrap: break-word;
}

.line-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.selected-item {
  background-color: #17a2b8;;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

}

.fitSizeImage {
  object-fit: cover;
}

.image-tags {
  max-width: 300px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  color: white;
}

.image-tags span {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

.image-description {
  max-width: 320px;
  min-width: 200px;
}

.tag-line {
  height: 1px;
  width: 50px;
  margin: 3px auto;
  display: inline-block;
  background-color: white;
}

.add-remove-tag {
  margin-top: 5px;
  color: white;
}
.filled-star {
  color: yellow;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: orange;
}
.icon-c {
  color: yellow;
}
.icon-d {
  color: yellow;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: orange;
}

body {
  margin: 0;
}

p {
  margin: 5px;
}

.star {
  width: 30px;
  aspect-ratio: 1;
  clip-path: polygon(79.90% 90.08%,50.31% 75.00%,21.12% 90.82%,26.32% 58.02%,2.26% 35.15%,35.05% 29.96%,49.37% 0.00%,64.44% 29.59%,97.35% 33.95%,73.87% 57.43%);
  background-color: #243C59;
}

.star-outline {
  width: 30px;
  aspect-ratio: 1;
  clip-path: polygon(79.90% 90.08%,50.31% 75.00%,21.12% 90.82%,26.32% 58.02%,2.26% 35.15%,35.05% 29.96%,49.37% 0.00%,64.44% 29.59%,97.35% 33.95%,73.87% 57.43%,79.90% 90.08%,50.31% 75.00%,50.21% 66.50%,69.73% 76.45%,65.76% 54.90%,81.25% 39.41%,59.53% 36.53%,49.59% 17.00%,40.13% 36.77%,18.49% 40.20%,34.37% 55.30%,30.94% 76.94%,50.21% 66.50%,69.73% 76.45%);
  background-color: #243C59;
}
</style>